import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import LoadingScreen from 'src/components/loading-screen';
import { useAuthContext } from './useAuthContext';

// ----------------------------------------------------------------------

type GuestGuardProps = {
  children: ReactNode;
};

export default function GuestGuard({ children }: GuestGuardProps) {
  const accessToken = localStorage.getItem('accessToken');
  
  const { isAuthenticated, isInitialized } = useAuthContext();

  if (isAuthenticated && accessToken ) {
    window.location.href = '/dashboard/charts/list';
    // return <Navigate to="/dashboard/folder/list" />;
  }

  if (!isInitialized) {
    return <LoadingScreen />;
  }

  return <> {children} </>;
}
